module.exports = __webpack_public_path__ + "static/media/empty-box.8bb6f219.svg";